import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import TextField from "src/components/TextField";

export default function RemoveFamilyDeviceWithPasswordDialog({
  isOpen,
  onDismiss,
  onRemove,
  onChange,
  password = "",
  deviceName = ""
}) {
  const { t } = useTranslation();
  const passwordInput = (
    <TextField
      autoFocus
      value={password}
      placeholder={t("placeholders.enterPassword")}
      type="password"
      onChange={onChange}
    />
  );

  return (
    <Dialog
      isOpen={isOpen}
      heading={t("pairedDevices.removeFamilyDeviceWithPasswordDialog.heading")}
      text={t("pairedDevices.removeFamilyDeviceWithPasswordDialog.text", {
        value0: deviceName
      })}
      buttons={[
        {
          text: t("buttons.cancel"),
          onClick: onDismiss
        },
        {
          text: t("buttons.delete"),
          onClick: onRemove,
          disabled: !password
        }
      ]}
      additionalContent={passwordInput}
    />
  );
}
